// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import isEqual from 'lodash.isequal';
import matches from 'lodash.matches';
var comparisonOperators = {
    $eq: isEqual,
    $neq: function (v1, v2) { return !isEqual(v1, v2); },
    $gt: function (v1, v2) { return v1 > v2; },
    $gte: function (v1, v2) { return v1 >= v2; },
    $lt: function (v1, v2) { return v1 < v2; },
    $lte: function (v1, v2) { return v1 <= v2; },
    $includes: function (v1, v2) {
        return v1 === null || v1 === void 0 ? void 0 : v1.includes(v2);
    },
    $nincludes: function (v1, v2) {
        return !(v1 === null || v1 === void 0 ? void 0 : v1.includes(v2));
    },
    $matches: function (v1, v2) { return matches(v1)(v2); },
};
var logicalOperators = {
    $and: function (item, queries, customValues) {
        return queries.find(function (query) { return !runQuery(item, query, customValues); });
    },
    $or: function (item, queries, customValues) {
        return !queries.find(function (query) { return runQuery(item, query, customValues); });
    },
};
export function runComparison(v1, v2, operator) {
    if (operator === void 0) { operator = '$eq'; }
    var operation = comparisonOperators[operator];
    return operation(v1, v2);
}
export function runLogicalOperation(item, queries, operator, customValues) {
    if (operator === void 0) { operator = '$and'; }
    var operation = logicalOperators[operator];
    return operation(item, queries, customValues);
}
export function hasValue(value) {
    return (value !== null && value !== undefined) || typeof value === 'boolean' || !isEmpty(value);
}
export function parseIfJsonFormat(value) {
    if (!value || typeof value !== 'string')
        return value;
    return value.match(/\[.*\]/) ? JSON.parse(value) : value;
}
export function runQuery(item, query, customValues) {
    if (isEmpty(query))
        return true;
    return !Object.keys(query).find(function (attrOrOpName) {
        var parsedAttrOrOpName = parseIfJsonFormat(attrOrOpName);
        var hasComparisonOperation = !!comparisonOperators[attrOrOpName];
        var hasLogicalOperation = !!logicalOperators[attrOrOpName];
        var nextQueryOrComparatorValue = parseIfJsonFormat(query[attrOrOpName]);
        var defaultAttrValue = hasComparisonOperation || hasLogicalOperation ? item : undefined;
        var attrValue = get(item, parsedAttrOrOpName, get(customValues, parsedAttrOrOpName, defaultAttrValue));
        var comparatorValue = (nextQueryOrComparatorValue === null || nextQueryOrComparatorValue === void 0 ? void 0 : nextQueryOrComparatorValue.length)
            ? get(customValues, nextQueryOrComparatorValue, nextQueryOrComparatorValue)
            : nextQueryOrComparatorValue;
        if (hasComparisonOperation)
            return !runComparison(attrValue, comparatorValue, attrOrOpName);
        if (hasLogicalOperation)
            return runLogicalOperation(attrValue, nextQueryOrComparatorValue, attrOrOpName, customValues);
        return !runQuery(attrValue, nextQueryOrComparatorValue, customValues);
    });
}
